// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2mgRk","options":"AnswerScale_options__2VUdj","selected":"AnswerScale_selected__2O6WQ"};